import dayjs from 'dayjs';

import { ConvertedHoliday, Holiday } from '../types';

export const convertPayloadForSave = (data: Holiday): ConvertedHoliday => {
  return {
    ...data,
    date: dayjs(data.date).startOf('day').toISOString()
  };
};
